import angular from "angular";
import Vue from "vue";
import "ngVue";

import PasswordRequirements from "./PasswordRequirements.vue";

export default angular
  .module("directives.passwordrequirements", [])
  .directive("passwordRequirements", [
    "createVueComponent",
    function (createVueComponent) {
      return createVueComponent(
        Vue.component("PasswordRequirements", PasswordRequirements),
      );
    },
  ]);

